/**
 * Path helper for a file in `apps/web/public/`.
 *
 * Vite copies `public/` to the root of the build. It also rebases a reference
 * to one of those files that it can read: an `href` or a `src` in `index.html`,
 * and a `url()` in a stylesheet. A path in TypeScript is a plain string, and
 * the build cannot know that the string is a path. A literal
 * `/logos/septima.svg` therefore stays absolute in the bundle. Under a base
 * path it asks the root of the site, not the application, and the site answers
 * 404. The SCENARIO COPY is such a build (`VITE_BASE=/review/dowgate/app/`), because
 * the reviewer's site shows it inside a frame under a prefix.
 *
 * This helper puts `import.meta.env.BASE_URL` in front of the path. Production
 * and staging build with the base `/`, so the result is the same string that
 * the caller gives, and the change is a no-op there.
 *
 * `BASE_URL` always ends in a slash, so the helper removes the trailing slash
 * of the base and the leading slash of the path. One slash joins the two.
 *
 * Use this helper for a path in TypeScript only. Keep an `index.html` attribute
 * and a CSS `url()` absolute, because Vite rebases those already.
 */
export function publicAssetPath(path: string): string {
    const base = import.meta.env.BASE_URL.replace(/\/$/, '');
    return `${base}/${path.replace(/^\/+/, '')}`;
}
